"use strict";
// @generated by protoc-gen-connect-es v1.4.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/event/v1/legacy_portal_service.proto (package spwn.event.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.LegacyPortalEventService = void 0;
const legacy_portal_service_pb_1 = require("./legacy_portal_service_pb");
const protobuf_1 = require("@bufbuild/protobuf");
/**
 * @generated from service spwn.event.v1.LegacyPortalEventService
 */
exports.LegacyPortalEventService = {
    typeName: "spwn.event.v1.LegacyPortalEventService",
    methods: {
        /**
         * イベントグッズをウォッチリストに追加
         *
         * @generated from rpc spwn.event.v1.LegacyPortalEventService.AddEventGoodsToWatchlist
         */
        addEventGoodsToWatchlist: {
            name: "AddEventGoodsToWatchlist",
            I: legacy_portal_service_pb_1.LegacyPortalEventServiceAddEventGoodsToWatchlistRequest,
            O: legacy_portal_service_pb_1.LegacyPortalEventServiceAddEventGoodsToWatchlistResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * イベントグッズをウォッチリストから削除
         *
         * @generated from rpc spwn.event.v1.LegacyPortalEventService.RemoveEventGoodsFromWatchlist
         */
        removeEventGoodsFromWatchlist: {
            name: "RemoveEventGoodsFromWatchlist",
            I: legacy_portal_service_pb_1.LegacyPortalEventServiceRemoveEventGoodsFromWatchlistRequest,
            O: legacy_portal_service_pb_1.LegacyPortalEventServiceRemoveEventGoodsFromWatchlistResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * ユーザのウォッチリストを取得
         *
         * @generated from rpc spwn.event.v1.LegacyPortalEventService.GetWatchlistEventGoods
         */
        getWatchlistEventGoods: {
            name: "GetWatchlistEventGoods",
            I: legacy_portal_service_pb_1.LegacyPortalEventServiceGetWatchlistEventGoodsRequest,
            O: legacy_portal_service_pb_1.LegacyPortalEventServiceGetWatchlistEventGoodsResponse,
            kind: protobuf_1.MethodKind.Unary,
            idempotency: protobuf_1.MethodIdempotency.NoSideEffects,
        },
        /**
         * idを指定してイベントグッズを取得
         *
         * @generated from rpc spwn.event.v1.LegacyPortalEventService.GetAllEventGoodsByEventGoodsFirestoreIds
         */
        getAllEventGoodsByEventGoodsFirestoreIds: {
            name: "GetAllEventGoodsByEventGoodsFirestoreIds",
            I: legacy_portal_service_pb_1.LegacyPortalEventServiceGetAllEventGoodsByEventGoodsFirestoreIdsRequest,
            O: legacy_portal_service_pb_1.LegacyPortalEventServiceGetAllEventGoodsByEventGoodsFirestoreIdsResponse,
            kind: protobuf_1.MethodKind.Unary,
            idempotency: protobuf_1.MethodIdempotency.NoSideEffects,
        },
    }
};
//# sourceMappingURL=legacy_portal_service_connect.js.map